// Angular
import { Injectable } from '@angular/core';

@Injectable()
export class ProcessingSmsService {
    private formModel;

    public get form () {
        return this.formModel;
    }

    public set form (value) {
        this.formModel = value;
    }
}
